import { render, staticRenderFns } from "./stereoacuity.config.vue?vue&type=template&id=6aa3990a"
import script from "./stereoacuity.config.vue?vue&type=script&lang=js"
export * from "./stereoacuity.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports